import { createTheme, ThemeOptions } from "@mui/material";

// Extend the theme's text palette type
declare module '@mui/material/styles' {
	interface TypeText {
		primary: string;
		secondary: string;
		tertiary: string;
	}
}

const theme = createTheme({
	palette: {
		mode: "light",
		primary: {
			main: "#178EFC",
			dark: "#1272CA",
		},
		text: {
			primary: "#000000",  // Main text color
			secondary: "#666666",    // Secondary text color
			tertiary: "#333333",     // Light grey text
		},
		secondary: {
			main: "#22B060", // green
		},
	},
	typography: {
		fontFamily: "'Inter', sans-serif",
	},
	components: {
		MuiButton: {
			styleOverrides: {
				root: {
					borderRadius: "8px",
					fontFamily: "'Inter', sans-serif",
					textTransform: "capitalize",

					variants: [
						{
							props: { variant: "outlined", color: "primary" },
							style: {
								// backgroundColor: '#000000',
								// color: '#ffffff',
								// borderColor: "yellow",
								// borderRadius: '8px',
								// fontSize: '16px',
								// fontWeight: '500',
								// padding: '12px 28px',
								// textTransform: 'none',
							},
						},
						{
							props: { variant: "contained", color: "primary" },
							style: {
								backgroundColor: "#178EFC",
								boxShadow: "none",
								textTransform: "capitalize",
								"&:hover": {
									boxShadow: "none",
									backgroundColor: "#006dd1",
								},
							},
						},
						{
							props: { variant: "text", color: "error" },
							style: {
								"&:hover": {
									backgroundColor: "#F9DADE",
								},
							},
						},
					],
				},

				// sizes
				sizeLarge: {
					minHeight: "40px",
					fontsize: "1rem",
					padding: "0px 24px",
				},
			},
		},
		MuiTooltip: {
			styleOverrides: {
				tooltip: {
					backgroundColor: "#000",
					color: "#fff",
					minHeight: "36px",
					display: "flex",
					alignItems: "center",
					justifyContent: "center",
					fontSize: "14px",
					padding: "6px 16px",
				},
				arrow: {
					color: "#000",
				},
			},
		},
		MuiTextField: {
			styleOverrides: {
				root: {
					"& .MuiInputLabel-root": {
						lineHeight: "normal",
					},
					variants: [
						{
							props: { size: "small" },
							style: {
								"& .MuiInputBase-root": {
									borderRadius: "4px",
								},
							},
						},
						{
							props: { size: "medium" },
							style: {
								"& .MuiInputBase-root": {
									borderRadius: "8px",
								},
								"& .MuiInputBase-input": {
									padding: "10px 14px",
								},
							},
						},
					],
				},
			},
		},
		MuiSelect: {
			styleOverrides: {
				root: {
					"& .MuiSelect-select": {
						padding: "9.5px 14px",
						borderRadius: "6px",

						"& ul": {
							padding: "4px",
						},

						"& li": {
							borderRadius: "4px",
						},
					},
				},
			},
		},
	},
});

export default theme;
